import React, { useCallback, useRef, useState } from "react";
import { Box, Text, chakra, shouldForwardProp } from "@chakra-ui/react";
import { ArrowUpCircleIcon, PlayCircleIcon } from "@heroicons/react/24/solid";
import { isValidMotionProp, motion } from "framer-motion";
import { UpsellBadge } from "./upsell-badge";
import { UpsellButton } from "./upsell-button";
const MotionButton = chakra(motion.button, {
    shouldForwardProp(prop) {
        return isValidMotionProp(prop) || shouldForwardProp(prop);
    },
});
const Video = chakra("video");
export function ExtendedUpsellCard({ badgeText, title, children, actionText, videoUrl, videoPoster, imageUrl, onAction, ...props }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const video = useRef(null);
    const play = useCallback(() => {
        void video.current?.play();
        setIsPlaying(true);
    }, []);
    return (React.createElement(Box, { border: "1px", borderColor: "ocean", borderRadius: "md", bg: "gray.100", ...props },
        React.createElement(Box, { px: 6, py: 4, display: "flex", gap: 6 },
            React.createElement(Box, { flex: "1", minWidth: 0 },
                React.createElement(UpsellBadge, null, badgeText),
                React.createElement(Text, { as: "h3", fontFamily: "upsell", color: "space.light", fontSize: "2xl", fontWeight: "medium", mt: 4 }, title),
                React.createElement(Box, { mt: 2, maxWidth: "65ch" }, children),
                React.createElement(Box, { mt: 6 },
                    React.createElement(UpsellButton, { icon: ArrowUpCircleIcon, onClick: onAction }, actionText))),
            videoUrl && (React.createElement(Box, { flex: "none", width: "sm" },
                React.createElement(Box, { position: "relative", borderRadius: "md", overflow: "hidden" },
                    React.createElement(Video, { ref: video, src: videoUrl, poster: videoPoster, controls: isPlaying, preload: "auto", maxWidth: "100%" }),
                    !isPlaying && (React.createElement(Box, { position: "absolute", inset: 0, bg: "blackAlpha.700", display: "flex", alignItems: "center", justifyContent: "center" },
                        React.createElement(MotionButton, { type: "button", boxSize: 20, whileHover: { scale: 1.1 }, onClick: play },
                            React.createElement(Box, { as: PlayCircleIcon, width: "100%", color: "white" }))))))),
            imageUrl && (React.createElement(Box, { flex: "none", width: "sm" },
                React.createElement(Box, { as: "img", src: imageUrl, loading: "lazy", maxWidth: "100%", alt: "", borderRadius: "md" }))))));
}
